module.exports = __webpack_public_path__ + "img/register-eye-open.e0265443.svg";